import React, { useEffect, useRef } from 'react'

import { Swiper, SwiperSlide } from 'swiper/react'

import { Navigation,Pagination  } from 'swiper/modules';


import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/grid';
import 'swiper/css/pagination'
import { HiOutlineChevronLeft, HiOutlineChevronRight } from 'react-icons/hi';
import { sliders } from '../lib/FakeData';
import Slide from './Slide';

export const Slider = ({ item }) => {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const swiperRef = useRef(null);

    useEffect(() => {
        if (swiperRef.current && swiperRef.current.params.navigation !== false) {
          swiperRef.current.params.navigation.prevEl = prevRef.current;
          swiperRef.current.params.navigation.nextEl = nextRef.current;
          swiperRef.current.navigation.init();
          swiperRef.current.navigation.update();
        }
      }, []);
    return (
        <div className='w-full flex justify-center items-center mt-4 group '>
            <div className='w-full px-4 xl:p-0 xl:w-[--page-width] flex items-center justify-center relative'>
            <Swiper
  modules={[Navigation, Pagination]}
  slidesPerView={1}
  spaceBetween={0}
  onSwiper={(swiper) => (swiperRef.current = swiper)}
  pagination={{ clickable: true }} // bật mặc định
  navigation={false} // tắt mặc định
  breakpoints={{
    768: {
      // Từ tablet trở lên
      pagination: false,
      navigation: {
        prevEl: prevRef.current,
        nextEl: nextRef.current,
      },
    },
  }}
>
                    {sliders?.map((item, index) => (
                        <SwiperSlide key={index}   >
                            <Slide item={item} />
                        </SwiperSlide>
                    ))}

                </Swiper>
                {/* Custom buttons */}
                <button
                    ref={prevRef}
                    className="hidden md:flex  absolute left-2 top-1/2 -translate-y-1/2 z-10 p-2 
               bg-[--color-button-3] text-[--color-button-1] rounded-full
               opacity-0 -translate-x-5
               group-hover:opacity-100 group-hover:translate-x-0
               transition-all duration-300 ease-in-out
               hover:bg-[--color-button-2]"
                >
                    <HiOutlineChevronLeft />
                </button>

                {/* Nút Next */}
                <button
                    ref={nextRef}
                    className="hidden md:flex absolute right-2 top-1/2 -translate-y-1/2 z-10 p-2 
               bg-[--color-button-3] text-[--color-button-1] rounded-full
               opacity-0 translate-x-5
               group-hover:opacity-100 group-hover:translate-x-0
               transition-all duration-300 ease-in-out
               hover:bg-[--color-button-2]"
                >
                    <HiOutlineChevronRight />
                </button>
            </div>


        </div>
    )
}
